var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMagicWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.678 1.697-.318.658-.664.322L5.031 3l.665.323.664.323.318.657c.174.361.323.652.33.645.007-.007.152-.304.323-.659l.311-.645.647-.313c.356-.172.647-.321.647-.331 0-.01-.291-.159-.647-.331l-.647-.313-.311-.645a25.741 25.741 0 0 0-.323-.659c-.007-.007-.156.284-.33.645m4.936.212c-.21.047-.507.177-.699.305-.137.093-8.567 8.495-8.848 8.82a1.92 1.92 0 0 0-.486 1.193 1.93 1.93 0 0 0 .63 1.565c.373.344.744.498 1.259.521a1.79 1.79 0 0 0 .983-.199l.254-.121 4.496-4.497L13.699 5l.124-.253a1.8 1.8 0 0 0 .203-.894c0-.359-.053-.59-.204-.893-.106-.212-.166-.293-.368-.493-.414-.413-.771-.57-1.334-.589a1.93 1.93 0 0 0-.506.031m.716.976c.149.043.357.177.472.305.264.294.325.758.145 1.115-.1.197-8.765 8.859-8.947 8.944-.257.119-.633.118-.875-.003a1.058 1.058 0 0 1-.464-.467c-.081-.165-.088-.197-.088-.445 0-.475-.429-.004 4.517-4.951 2.408-2.409 4.405-4.386 4.457-4.412.23-.116.555-.152.783-.086",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagicWand);
export default __webpack_public_path__ + "static/media/icon-magicWand.cf9ddd39032da4de1e2814cbcb71fc54.svg";
export { ForwardRef as ReactComponent };